import { any, curry, flip } from 'ramda';

export enum EventType {
  Click = 'click',
  KeyDown = 'keydown',
  Hover = 'hover',
  MouseLeave = 'mouseleave',
  End = 'end'
}

export enum KeyCode {
  Tab = 9,
  Down = 40,
  Up = 38,
  Left = 37,
  Right = 39,
  Enter = 13,
  Esc = 27,
  Backspace = 8,
  Delete = 46
}

export const isEvent = curry((keyCode: KeyCode, event: KeyboardEvent) =>
  event.which === keyCode
);

const isKeyCode = flip(isEvent);

export const isOneOf = curry((keyCodes: KeyCode[], event: KeyboardEvent) => any(
  isKeyCode(event),
  keyCodes
));
